<template>
  <div>
    <div class="row mt-3">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fields"
          :actions="actions"
          :items="lstExclusaoSolicitacao"
          responsive
          sortBy="idsolicitacao"
          :porPage="itemPorPage"
          search
          pagination
          :titlePage="titlePDF"
          :titlePDF="titlePDF"
        >
        </fccTable>
      </div>
    </div>
    <fccModal
      centered
      idModal="addComplementoModal"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
      @close="criar = {}"
    >
      <form
        @submit.prevent="criar.idcomplemento == 0 ? criarComplemento() : editarComplemento()"
        autocomplete="off"
      >
        <div class="row">
          <div class="col-sm-12">
            <fccInput
              extraClasses="inputLabel"
              :required="criar.fonte == '' || criar.fonte == null"
              v-model="criar.descricao"
              >Descrição</fccInput
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-6">
            <fcc-select
              v-model="criar.fonte"
              :options="lstFonte"
              :required="criar.descricao == '' || criar.descricao == null"
              >Fonte</fcc-select
            >
          </div>
          <div class="col-sm-6" v-if="criar.fonte">
            <fcc-select v-model="criar.tamanho" :options="lstTamanho" required :clearable="false"
              >Tamanho</fcc-select
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-12 text-right">
            <fccButton tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>

<script>
import store from '@/store'
import axios from 'axios'
export default {
  data() {
    return {
      itemPorPage: 100,
      lstSolicitacaoEspecifica: [],
      solicitaItem: '',
      lstFonte: [
        'Arial',
        'Arial Negrito',
        'Arial Black',
        'Arial Black Negrito',
        'Times New Roman',
        'Verdana'
      ],
      lstTamanho: [18, 24, 28],
      titleModal: '',
      lstExclusaoSolicitacao: [],
      criar: {},
      titlePDF: 'Solicitações Específicas',
      fields: [
        { key: 'idcomplementopublicacao', label: 'ID', sortable: true, active: true },
        { key: 'descricao', label: 'Descrição', sortable: true, active: true },
        { key: 'fonte', label: 'Fonte', sortable: true, active: true },
        { key: 'tamanho', label: 'Tamanho', sortable: true, active: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'deleteComplemento',
          icon: 'trash',
          tooltip: 'Deletar',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  props: {
    solicitacao: {
      type: Object,
      require: true
    }
  },
  methods: {
    deleteComplemento(_, item) {
      this.callConfirm(
        this.mensagemExcluir,
        item.descricao == null ? item.fonte : item.descricao
      ).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlLaudoMedico +
                'MetadadoSolicitacaoCondicaoPublicacao/Excluir/' +
                item.idcomplementopublicacao,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.sucessoSituacao(this.mensagensUpdate.excluido)
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto)
        }
      })
    },
    sucessoSituacao(texto) {
      this.solicitaItem = ''
      this.listaMetadadoComplemento()
      this.$root.$emit('bv::hide::modal', 'addComplementoModal')
      this.callToast(texto)
    },
    listaMetadadoComplemento() {
      this.ListarMetadadoSolicitacaoCondicaoComplemento(
        this.solicitacao.idsolicitacaopublicacao
      ).then((response) => {
        this.lstExclusaoSolicitacao = response
      })
    }
  },
  mounted() {
    this.listaMetadadoComplemento()
  }
}
</script>